import {Injectable} from '@angular/core';
import {DeviceDetectorService, DeviceInfo} from "ngx-device-detector";
import {Device, LoggingDetail} from "../model/logging/logging-detail";
import packageJson from "../../../../package.json";

@Injectable({
    providedIn: 'root' // ✅ Ensures the service is available globally
})
export class LoggingDetailsService {
    constructor(
        private deviceDetectorService: DeviceDetectorService,
    ) {}

    public getUserDetails(): LoggingDetail {
        return {
            clientVersion: packageJson.version,
            device: this.geDevice()
        };
    }

    private geDevice(): Device {
        const deviceInfo: DeviceInfo = this.deviceDetectorService.getDeviceInfo();
        if (!deviceInfo) {
            return null;
        }
        return {
            userAgentString: deviceInfo.userAgent,
            os: {
                name: deviceInfo.os,
                version: deviceInfo.os_version
            },
            browser: {
                name: deviceInfo.browser,
                version: deviceInfo.browser_version
            },
            deviceType: this.deviceDetectorService.deviceType()
        };
    }
}